import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import './styles/tokens.css';
import './styles/textures.css';
import './styles/components.css';
import './styles/payroll.css';

import App from './App.jsx';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Crew clock state and admin data both want freshness over staleness.
      // 30s feels right for most lists; specific hooks can override.
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
